export default "__VITE_ASSET__C8ZJB0ES__"